import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../../Apiurl";
import SpedizioniDelGiorno from "./SpedizioniDelGiorno";
import CorrispettiviMese from "./CorrispettiviMese";
import XweeksYordini from "./XweeksYordini";
import X6giorniYordini from "./X6giorniYordini";
import XmesiYcorrieri from "./XmesiYcorrieri";
import XmesiYmarketplaces from "./XmesiYmarketplaces";
import XmesiYmotiviAnnullamenti from "./XmesiYmotiviAnnullamenti";
import XmesiYgraneMarketplace from "./XmesiYgraneMarketplace";

function ContainerLoaderCharts({
  query,
  titolo,
  displayTitolo,
  dataLista,
  key,
  tipo,
  settings,
  colorMap,
}) {
  const [data, setData] = useState(false);
  const { user, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [key1, setKey1] = useState(1);

  useEffect(() => {
    setKey1(key);
  }, [key]);

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    fetch(apiUrl + query, { headers: { Authorization: "Bearer " + token } })
      .then((resp) => resp.json())
      .then((data) => setData(data));
  }, [token, dataLista, settings, query]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  // esegue query

  if (titolo === "Stats") {
    return (
      <SpedizioniDelGiorno
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        key={key1 + 1}
      />
    );
  } else if (titolo === "Corrispettivi") {
    let importoString;
    if (data?.resultsRicercaOrdiniTOT?.[0]?.["SommaDiTot_imp_spedizione"]) {
      importoString =
        data.resultsRicercaOrdiniTOT[0]["SommaDiTot_imp_spedizione"]
          .toString()
          .replace(".", ",")
          .replace(/\d(?=(?:(?:\d{3})+),)/g, (match) => `${match}.`) + " €";
    }
    let ordiniString;
    if (data?.resultsRicercaOrdiniTOT?.[0]?.["Numero scontrini"]) {
      ordiniString = data.resultsRicercaOrdiniTOT[0]["Numero scontrini"];
    }
    return (
      <div>
        <div className="pl3 pr3 pt3">
          Dati relativi alle spedizioni comprese tra{" "}
          <strong>
            {data.dataStart} e {data.dataEnd}
          </strong>{" "}
          confrontate con gli ultimi 4 anni
          <br />
        </div>
        <CorrispettiviMese
          data={data}
          titolo={titolo}
          displayTitolo={displayTitolo}
          key={key1 + 2}
        />
        <div className="pl3 pr3 pb1">
          Dati relativi alle spedizioni comprese tra{" "}
          <strong>
            {data.dataStart} e {data.dataEnd}
          </strong>
          <br />
          Totale importo: <strong>{importoString}</strong>
          <br />
          Totale scontrini: <strong>{ordiniString}</strong>
          <br />
        </div>
      </div>
    );
  } else if (tipo === "corrispettiviMeseRimborsi") {
    let importoString;
    if (data?.resultsRicercaOrdiniTOT?.[0]?.["SommaDiTotale_rimborso"]) {
      importoString =
        data.resultsRicercaOrdiniTOT[0]["SommaDiTotale_rimborso"]
          .toString()
          .replace(".", ",")
          .replace(/\d(?=(?:(?:\d{3})+),)/g, (match) => `${match}.`) + " €";
    }
    let ordiniString;
    if (data?.resultsRicercaOrdiniTOT?.[0]?.["Numero rimborsi"]) {
      ordiniString = data.resultsRicercaOrdiniTOT[0]["Numero rimborsi"];
    }
    return (
      <div>
        <div className="pt3 pl3 pr3 pb1">
          Dati relativi alle spedizioni comprese tra{" "}
          <strong>
            {data.dataStart} e {data.dataEnd}
          </strong>
          <br />
          Totale importo: <strong>{importoString}</strong>
          <br />
          Totale rimborsi: <strong>{ordiniString}</strong>
          <br />
        </div>
      </div>
    );
  } else if (tipo === "x6giorniAnnoyOrdini") {
    return (
      <X6giorniYordini
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
      />
    );
  } else if (tipo === "linesSpedizioniAnni") {
    return (
      <XweeksYordini
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        settings={settings}
        colorMap={colorMap}
      />
    );
  } else if (tipo === "linesSpedizioniCorrieri") {
    return (
      <XmesiYcorrieri
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        settings={settings}
      />
    );
  } else if (tipo === "linesSpedizioniMarketplaces") {
    return (
      <XmesiYmarketplaces
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        settings={settings}
      />
    );
  } else if (tipo === "linesSpedizioniAnnullate") {
    return (
      <XmesiYmotiviAnnullamenti
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        settings={settings}
      />
    );
  } else if (tipo === "linesGraneCorrieri") {
    return (
      <XmesiYgraneMarketplace
        data={data}
        titolo={titolo}
        displayTitolo={displayTitolo}
        settings={settings}
      />
    );
  } else {
    return (
      <p>Nessun componente grafico associato a questo titolo. ({titolo})</p>
    );
  }
}

export default ContainerLoaderCharts;
